// WP3 — deterministic search-term suggestions for the wizard's visibility
// step (spec §8 step 2: "3 suggested search terms, auto from category,
// editable"). Pure leaf. Inputs come from the site's canonical identity
// (sites.primaryCategory / sites.addressCity via GET business-info); output
// is ONLY a pre-fill — the owner edits freely and PUT /api/geo/schedule
// normalizes/caps server-side regardless. Honesty: no category → no
// suggestions; no city → no place-name is ever invented.

/** Longest single search term we accept. Matches tracked-search-terms.ts
 *  for consistency (kept as local const to preserve bare-node leaf rule). */
export const SEARCH_TERM_MAX_LENGTH = 120;

export interface SuggestSearchTermsInput {
  category: string | null | undefined;
  city: string | null | undefined;
}

function clean(raw: string | null | undefined): string {
  return (raw ?? '').replace(/\s+/g, ' ').trim().toLowerCase();
}

export function suggestSearchTerms(input: SuggestSearchTermsInput): string[] {
  const category = clean(input.category);
  if (!category) return [];
  const city = clean(input.city);
  const candidates = city
    ? [`${category} ${city}`, `${category} near me`, `best ${category} in ${city}`]
    : [`${category} near me`, category];
  const out: string[] = [];
  for (const c of candidates) {
    if (c.length === 0 || c.length > SEARCH_TERM_MAX_LENGTH) continue;
    if (!out.includes(c)) out.push(c);
    if (out.length === 3) break;
  }
  return out;
}
